import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress React dev-mode postMessage errors (non-cloneable Request/Response objects)
window.addEventListener('error', (event) => {
  // Benign, noisy dev-mode warning that triggers react-error-overlay and can
  // intercept clicks in the preview. Safe to swallow (never fires in prod build).
  if (event.message?.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
  if (event.message?.includes('postMessage') && event.message?.includes('cloned')) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
});
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || String(event.reason || '');
  if (msg.includes('postMessage') && msg.includes('cloned')) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// Service-worker policy: NONE.
//
// The PWA install benefit was never worth the recurring "stale SW
// hijacks fetch on deploy" pain in production. We now actively
// EVICT any service worker the browser is holding on every page load
// and never register a new one. The /service-worker.js file at the
// root has been turned into a self-destructing "kill switch" — when
// the browser activates it, it unregisters itself and wipes all
// caches. After one such activation, the browser is permanently
// SW-free until something registers one again.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister().catch(() => false)));
      if (window.caches && caches.keys) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k).catch(() => false)));
      }
    } catch { /* ignore — best-effort eviction */ }
  });
}
